import { getLogger } from '../diagnostics/logger';
import {
  LOAD_COMMAND_DEFINITIONS_FAILURE,
  LOAD_COMMAND_DEFINITIONS_PENDING,
  LOAD_COMMAND_DEFINITIONS_SUCCESS,
} from '../actions/actionTypes';
import { Action, ActionMeta } from '../actions/commonActions';
import { Loadable } from '../models';
import { SimManagementError } from '../models/Errors';
import { initialAppState } from '../models/state/appState';
import { CommandDefinitionsState, SimCommandDefinitions } from '../models/state/commandDefinitionState';
import { SimCommandDefinition } from '../models/transfer/input/SimCommandDefinition';

const log = getLogger('simManagement.reducers.commandDefinitionsReducer');

export default function commanDefinitionsReducer(
  state: CommandDefinitionsState = initialAppState.commandDefinitions,
  action: Action<any>,
): CommandDefinitionsState {
  switch (action.type) {
    case LOAD_COMMAND_DEFINITIONS_PENDING: {
      const { payload } = action as Action<string>;
      if (!payload) {
        return state;
      }

      const commandType = payload;
      const definition: Loadable<SimCommandDefinitions> = {
        isLoading: true,
        byType: {},
      };

      const newState: CommandDefinitionsState = Object.assign({}, state, {
        [commandType]: definition,
      });

      return newState;
    }
    case LOAD_COMMAND_DEFINITIONS_FAILURE: {
      const { meta, payload } = action as ActionMeta<SimManagementError, string>;
      if (!meta) {
        log.warn('No meta');
        return state;
      }

      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const commandType = meta;
      const error = payload;
      const definition: Loadable<SimCommandDefinitions> = {
        isLoading: false,
        byType: {},
        error,
      };

      const newState: CommandDefinitionsState = Object.assign({}, state, {
        [commandType]: definition,
      });

      return newState;
    }

    case LOAD_COMMAND_DEFINITIONS_SUCCESS: {
      const { meta, payload } = action as ActionMeta<SimCommandDefinition[], string>;
      if (!meta) {
        log.warn('No meta');
        return state;
      }

      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const commandType = meta;
      const commandDefinitions = payload;
      const definition: Loadable<SimCommandDefinitions> = {
        isLoading: false,
        byType: Object.assign({}, ...commandDefinitions.map((a) => ({ [a.type]: a }))),
      };

      const newState: CommandDefinitionsState = Object.assign({}, state, {
        [commandType]: definition,
      });

      return newState;
    }
    default:
      return state;
  }
}
